export const bg = "var(--seed-color-manner-temp-l4-bg)";
export const text = "var(--seed-color-manner-temp-l4-text)";